import { computed, inject, Injectable, Signal } from '@angular/core';
import { Configuration } from '../models/interfaces/configuration/index.interface';
import { APP_CONFIG } from '../configuration/configuration';

@Injectable({
  providedIn: 'root'
})
export class UiService {

  // APP CONFIG
  private readonly appConfig: Signal<Configuration> = inject(APP_CONFIG);

  // UI CONFIG
  public readonly  uiConfig:  Signal<Configuration['Ui']> = computed((): Configuration['Ui'] => this.appConfig()['Ui']);

}
